module.exports = __webpack_public_path__ + "static/img/zi1.6f3252fa.png";